<template>
  <transition-group
    name="fade"
    mode="out-in"
  >
    <recommendation-downloading-apps
      key="apps-recommendation"
      class="sticky-top"
      @closeRecommendation="showRecommendation = false"
      v-if="isMobile && showRecommendation"
    ></recommendation-downloading-apps>
    <nav
      key="navbar"
      class="navbar-wrapper sticky-top"
    >
      <navbar-logo v-if="!showSearchMobile || windowWidth >= 1024"></navbar-logo>
      <img
        v-else-if="showSearchMobile && windowWidth < 1024"
        id="hide-search-button"
        src="https://cdn.karier.mu/assets/v3/icon/arrow-left.svg"
        alt="arrow-left"
        @click="toggleSearchMobile()"
      >
      <div v-if="windowWidth >= 1024" class="align-self-center">
        <s-button
          id="home-button"
          tag="a"
          variant="text"
          cluster="k"
          size="small"
          class="text-gargoyle text-decoration-none"
          :href="isPrakerja ? hostname : `${hostname}/home`"
        >
          Home
        </s-button>
        <s-button
        id="programmu-button"
        tag="router-link"
        variant="text"
        cluster="k"
        size="small"
        :class="['link-divider text-decoration-none programmu-button', btnProgrammuClass]"
        :to="`/programmu${queryParam}`"
        @click="isPrakerja && logEventAnalytics('prakerja_programmu_click', {})"
        >
          Learn
        </s-button>
        <s-button
          id="profile-button"
          tag="a"
          variant="text"
          cluster="k"
          size="small"
          class="text-gargoyle text-decoration-none"
          :href="`${hostname}/profile/overview`"
        >
          Profile
        </s-button>
      </div>
      <navbar-search
        v-show="showSearchMobile || windowWidth >= 1024"
        ref="navbar-search"
        class="custom-mobile-search"
      ></navbar-search>
      <div
        v-if="!showSearchMobile"
        class="mobile-action-wrapper"
      >
        <img
          id="show-search-button"
          src="https://cdn.karier.mu/assets/v3/icon/icon-search-blue.svg"
          alt="icon-search"
          @click="toggleSearchMobile()"
        >
        <burger-navigation
          :is-open="isOpenDetailMenu"
          @toggleBurgerNav="toggleDetailMenu()"
        ></burger-navigation>
      </div>
      <div class="nav-right-container">
        <div
          v-if="isLogin"
          class="desktop-action-wrapper"
        >
          <router-link
            id="cart-button"
            class="action-button"
            :to="`/daftar-pilihan${queryParam}`"
            @click="isPrakerja && logEventAnalytics('prakerja_cart_icon_click', {})"
          >
            <div>
              <img
                id="cart-icon"
                alt="cart-icon"
                src="https://cdn.karier.mu/assets/v3/icon/daftar-pilihan.svg"
              />
              <b-tooltip
                target="cart-icon"
                variant="warning"
                triggers="hover"
              >
                Daftar Pilihan
              </b-tooltip>
            </div>
          </router-link>
          <router-link
            id="button-notifikasi"
            class="action-button"
            :to="`/notifikasi${queryParam}`"
          >
            <div>
              <icon-notifikasi></icon-notifikasi>
            </div>
          </router-link>
        </div>
        <collapse-menu
          v-if="isLogin"
          ref="collapse-avatar"
          ref-name="collapse-avatar"
          :custom-style="{ top: '70px', right: '48px' }"
          @toggle="toggleDetailMenu()"
        >
          <template #default="{ toggleOpen }">
            <div
              id="avatar-button"
              @click="toggleOpen()"
            >
              <s-avatar
                :src="`${urlServerImage}/100x100,fit/${avatar}`"
                class="user-avatar"
                cluster="k"
              ></s-avatar>
            </div>
          </template>
          <template #content="{ close }">
            <user-menu-desktop-v2
              @close="close()"
              @logout="logout"
            />
          </template>
        </collapse-menu>
      </div>

      <mobile-sidebar-menu-v2
        v-if="windowWidth < 1024"
        class="mobile-sidebar"
        :class="{ 'open': isOpenDetailMenu }"
        @close="toggleDetailMenu()"
        @logout="logout()"
      ></mobile-sidebar-menu-v2>

      <b-modal-kariermu
        :is-shown="isOpeningProgramTerbatas"
        no-close-on-backdrop
        no-close-on-esc
        centered
        hide-footer
        hide-header
        size="sm"
      >
        <modal-blocker-program-terbatas ></modal-blocker-program-terbatas>
      </b-modal-kariermu>

    </nav>
    <otp-verification key="otp-verification"/>
  </transition-group>
</template>

<script>
// NEW
import { defineAsyncComponent } from 'vue'
import { mapState } from 'vuex'
import NavbarLogo from '@/components/navbar/NavbarLogo.vue'
import NavbarSearch from '@/components/navbar/NavbarSearch.vue'
import BurgerNavigation from '@/components/navbar/BurgerNavigation.vue'
import CollapseMenu from '@/components/atoms/collapse/CollapseMenu.vue'
import IconNotifikasi from '@/components/navbar/iconNavbar/IconNotifikasi.vue'

// OLD
import { showErrorAlert } from '@/functions/showErrorAlert'
import axiosServer from '../../configs/axiosServer.js'

import ModalBlockerProgramTerbatas from '@/components/validator/ModalBlockerProgramTerbatasWarningOnly'
import Swal from 'sweetalert2'
import errorHandler5xx_desktop from '../../assets/images/errorHandler/login_5xx_desktop.png'
import errorHandler5xx_mobile from '../../assets/images/errorHandler/login_5xx_mobile.png'

// import CollapseList from '@/components/navbar/CollapseList'
import deviceDetector from 'mobile-device-detect'

// firebase notification
import MessagingService from '../../modules/messaging-service'
import desktopNotification from '../../functions/pushNotification/desktopNotification'

// otp
import OtpVerification from '@/components/otpUserVerification/OtpVerification.vue'

import discovery from '@/api/discovery.js'
import authMixin from '@/mixins/auth.js'
import platinumMixin from '@/mixins/platinumMixin'
import userMenuMixin from '@/mixins/userMenuMixin'

export default {
  components: {
    UserMenuDesktopV2: defineAsyncComponent(() => import('@/components/navbar/UserMenuDesktopV2.vue')),
    MobileSidebarMenuV2: defineAsyncComponent(() => import('@/components/navbar/MobileSidebarMenuV2.vue')),
    NavbarLogo,
    NavbarSearch,
    BurgerNavigation,
    CollapseMenu,
    IconNotifikasi,
    // CollapseList,
    ModalBlockerProgramTerbatas,
    OtpVerification
  },
  data () {
    return {
      isOpenDetailMenu: false,

      // OLD
      showRecommendation: false,
      isMobile: deviceDetector.isMobile,
      modalRegister: false,
      modalRegisterForm2: false,
      modalRegisterOAuthForm2: false,
      modalNewPassword: false,
      modalConfirmationPassword: false,
      modalConfirmationRegister: false,
      isShowEmailVerificationModal: false,
      isShowEmailNotYetVerified: false,
      isShowProfileUncompleted: false,
      isSend: false,
      email: '',
      isAgree: false,
      modalMasuk: false,
      isKeepLogin: false,
      passwordUser: '',
      emailUser: '',
      isClickable: false,
      isLoading: false,
      isShowPassword: false,
      errorMessage: '',
      isError: false,
      searchSelect: 'all',
      searchOptions: [
        'Semua',
        'Kelasmu',
        'Ujianmu',
        'Karirmu'
      ],
      dropdownLogin: false,
      showSearchMobile: false,
      dropdownProfile: false,
      searchTitle: '',
      isLoadingOauth: false,
      isClicked: false,
      windowWidth: window.innerWidth,
      categoryState: false
    }
  },
  mixins: [platinumMixin, userMenuMixin, authMixin],
  methods: {
    logEventAnalytics (eventName, additionalParams) {
      if (this.isLogin) {
        window.firebaseAnalytics.logEvent(eventName, {
          screen_url: window.location.href,
          user_profession: this.userInfo.profession_name,
          user_year_level: this.userInfo.year_level_name,
          user_is_admin: this.userInfo.is_admin,
          user_id: this.userInfo.id,
          source: this.isMobile ? 'mobile-web' : 'web',
          ...additionalParams
        })
      }
    },
    logEventTalentBusiness (eventName) {
      this.logEventAnalytics(eventName, {
        page_referrer: window.location.href
      })
    },
    // OLD
    openFunReportApps () {
      if (this.isMobile) {
        this.$store.commit('funReport/CHANGE_IS_OPEN_MODAL_INVITATION', true)
      } else {
        this.$store.commit('funReport/CHANGE_IS_OPEN_MODAL_INVITATION_QR', true)
      }
      if (this.isLogin) {
        window.firebaseAnalytics.logEvent('jurnal_refleksimu_click', {
          user_profession: this.userInfo.profession_name,
          user_year_level: this.userInfo.year_level_name,
          user_is_parent: !!((this.userInfo.profession_name === 'Orangtua' || this.userInfo.child.length)),
          user_id: this.userInfo.id,
          source: this.isMobile ? 'mobile-web' : 'web'
        })
      }
    },
    openModalRegisterOAuthForm2 () {
      this.modalRegisterOAuthForm2 = true
    },
    openModalRegisterForm2 () {
      this.modalRegisterForm2 = true
    },
    closeModalMasuk () {
      this.modalMasuk = false
      this.$store.commit('program/CHANGE_OPEN_PROGRAM_TERBATAS', { isOpen: this.isOpeningProgramTerbatas, isLoading: false })
    },
    searchNavbar (value) {
      this.searchTitle = value
    },
    toggleDaftar () {
      this.isSend = false
      this.modalMasuk = false
      this.modalNewPassword = false
      this.modalConfirmationPassword = false
      this.modalConfirmationRegister = false
      this.modalOtp = false

      this.modalRegister = !this.modalRegister
    },
    toggleEmailVerification () {
      this.isShowEmailVerificationModal = !this.isShowEmailVerificationModal
    },
    toggleMasuk (isClicked) {
      this.modalRegister = false
      this.modalNewPassword = false
      this.modalConfirmationPassword = false
      this.modalConfirmationRegister = false
      this.isClicked = !!isClicked

      this.modalMasuk = !this.modalMasuk
    },
    toggleNewPassword () {
      this.modalRegister = false
      this.modalMasuk = false
      this.modalConfirmationPassword = false
      this.modalConfirmationRegister = false

      this.modalNewPassword = !this.modalNewPassword
    },
    toggleConfirmationPassword () {
      this.modalRegister = false
      this.modalNewPassword = false
      this.modalMasuk = false
      this.modalConfirmationRegister = false

      this.modalConfirmationPassword = !this.modalConfirmationPassword
    },
    toggleConfirmationRegister () {
      this.modalMasuk = false
      this.modalRegister = false
      this.modalNewPassword = false
      this.modalConfirmationPassword = false

      this.modalConfirmationRegister = !this.modalConfirmationRegister
    },
    toHome () {
      this.$router.push('/')
    },
    toggleDetailMenu () {
      this.isOpenDetailMenu = !this.isOpenDetailMenu
    },
    toggleDropdownLogin () {
      this.dropdownLogin = !this.dropdownLogin
    },
    toggleShowPassword () {
      this.isShowPassword = !this.isShowPassword
    },
    toggleSearchMobile () {
      this.showSearchMobile = !this.showSearchMobile
      if (!this.showSearchMobile) {
        this.activateOverlay(false)
        this.$store.commit('discovery/SET_IS_OPEN_NAVBAR_RECOMMENDATION', false)
      } else {
        this.$nextTick(() => {
          this.$refs['navbar-search'].$refs['navbar-search-input'].$refs.searchbar.focus()
        })
      }
    },
    toProfile () {
      this.$router.push('/account')
    },
    toRouting (route) {
      this.$router.push(`${route}`)
    },
    route (route) {
      if (this.$route.path === route) {
        return true
      } else return false
    },
    routeFullPath (route, type) {
      if (type === 'includes') {
        if (this.$route.fullPath.includes(route)) {
          return true
        } else {
          return false
        }
      } else {
        if (this.$route.fullPath === route) {
          return true
        } else return false
      }
    },
    kartuPrakerja () {
      if (this.$route.path === '/kartuprakerja' || this.$route.path === '/panduan-prakerja' || this.$route.path === '/mitra-kolaborasi') {
        return true
      } else return false
    },
    karirmu () {
      if (this.$route.path === '/kariermu/industri-kreatif' || this.$route.path === '/kariermu/mesin-konstruksi' || this.$route.path === '/kariermu/pariwisata' || this.$route.path === '/kariermu/layanan-perawatan' || this.$route.path === '/kariermu') {
        return true
      } else return false
    },
    kelasmu () {
      if (this.$route.path === '/kelasmu/pelajar' || this.$route.path === '/kelasmu/mahasiswa' || this.$route.path === '/kelasmu/guru' || this.$route.path === '/kelasmu/orangtua') {
        return true
      } else return false
    },
    ikutProgram () {
      if (this.$route.path === '/ikutprogram') {
        return true
      } else return false
    },
    onOver (ref) {
      this.$refs[ref].visible = true
    },
    onLeave (ref) {
      this.$refs[ref].visible = false
    },
    async verification () {
      let source
      switch (this.$route.path) {
        case '/verification':
          source = 'kariermu-web-register'
          break
        case '/account':
          source = 'kariermu-web-profil'
          break
        case '/daftar-pilihan':
          source = 'kariermu-web-pembayaran'
          break
        case '/portofolio/profil':
          source = 'kariermu-web-portofolio'
          break
        case '/transkrip':
          source = 'kariermu-web-transkrip'
          break
        default:
          source = 'kariermu-web-aktivitas belajar'
          break
      }
      const { data } = await axiosServer({
        url: `/user/email_verification/?source=${window.btoa(source)}`,
        method: 'post',
        headers: {
          Authorization: process.env.VUE_APP_APP_KEY
        },
        data: {
          email: this.userVerification,
          code: this.codeVerification,
          source: 'web'
        }
      })
      if (data.status === 200) {
        Swal.fire({
          title: 'Email Terverifikasi',
          text: 'Selamat, email anda telah terverifikasi',
          icon: 'success'
        })
        this.$store.dispatch('storage/loginSetStorage', data)
        this.$store.dispatch('user/fetchUserData')
      } else {
        this.$router.push('/404')
      }
      this.$store.commit('SET_VERIFICATION', {
        verification: null, code: null
      })
    },
    async setFbMessaging () {
      this.msgService = new MessagingService()
      // Request permission
      await this.msgService.requestPermissionAsync()
      return this.msgService.getTokenAsync()
    },
    listenFirebaseNotif () {
      if (Notification.permission === 'granted') {
        this.setFbMessaging()

        window.firebaseMessaging.onMessage((payload) => {
          this.$store.commit('notification/SET_NEW_NOTIF', true)
          desktopNotification(payload.data.title, {
            body: payload.data.body,
            image: payload.data.icon,
            icon: 'https://cdn.karier.mu/assets/home/footer_logo.svg'
          }, '/notifikasi')
        })
      }
    },
    openNavbarRecommendation () {
      if (
        (
          !!this.$store.state.discovery.programSearchRecommendation.length ||
          !!this.$store.state.discovery.institutionSearchRecommendation.length
        ) &&
        !this.searchTitle &&
        !this.$store.state.envBelajar
      ) {
        this.activateOverlay(true)
        this.$store.commit('discovery/SET_IS_OPEN_NAVBAR_RECOMMENDATION', true)
      }
    },
    activateOverlay (value) {
      this.$emit('activateOverlay', value)
    },
    async fetchPopularKeyword () {
      try {
        const data = await discovery.fetchPopularKeyword('', this.accessToken)
        if (data.status === 200) {
          this.$store.commit('discovery/SET_POPULAR_KEYWORD', data.data)
        } else {
          throw data
        }
      } catch (err) {
        console.error(err)
      }
    },
    async fetchSearchProgramRecommendation () {
      try {
        const data = await discovery.fetchSearchProgramRecommendation('', this.accessToken)
        if (data.status === 200) {
          this.$store.commit('discovery/SET_PROGRAM_SEARCH_RECOMMENDATION', data.data)
        } else {
          throw data
        }
      } catch (err) {
        showErrorAlert(err, null, null, 'ERRV2DISC')
        console.error(err)
      }
    },
    async fetchSearchInstitutionRecommendation () {
      try {
        const data = await discovery.fetchSearchInstitutionRecommendation('', this.accessToken)
        if (data.status === 200) {
          this.$store.commit('discovery/SET_INSTITUTION_SEARCH_RECOMMENDATION', data.data)
        } else {
          throw data
        }
      } catch (err) {
        showErrorAlert(err, null, null, 'ERRV2DISC')
        console.error(err)
      }
    },
    handleWindowResize () {
      this.windowWidth = window.innerWidth
    }
  },
  computed: {
    ...mapState(['userVerification', 'codeVerification']),
    ...mapState('storage', ['accessToken']),
    ...mapState('profession', ['professions']),
    ...mapState('program', ['program', 'isOpeningProgramTerbatas', 'selectedProgramTerbatas']),
    urlKariermuPrakerja () {
      return process.env.VUE_APP_URL_REWRITE_PRAKERJA
    },
    // OLD
    enableFunReport () {
      return (String(process.env.VUE_APP_SET_ENABLE_FUN_REPORT) === 'true')
    },
    isShowFunReport () {
      return this.isLogin && this.userInfo.is_have_fun_report && this.enableFunReport
    },
    cdnEnv () {
      return process.env.VUE_APP_CDN_ENV
    },
    adminURL () {
      return process.env.VUE_APP_ADMIN_URL
    },
    isProfileComplete () {
      const { email, name, year_level_id, city, occupation } = this.userInfo

      if (this.getProfession.toLowerCase().includes('murid')) {
        return !!email && !!name && !!year_level_id /* && !!institution */
      } else if (this.getProfession.toLowerCase().includes('guru')) {
        return !!email && !!name /* && !!institution */
      } else if (this.getProfession.toLowerCase().includes('orangtua')) {
        return !!email && !!name
      } else if (this.getProfession.toLowerCase().includes('mahasiswa')) {
        return !!email && !!name /* && !!institution */
      } else if (this.getProfession.toLowerCase().includes('profesional') || this.getProfession.toLowerCase().includes('professional')) {
        return !!email && !!name
      } else if (this.getProfession.toLowerCase().includes('prakerja')) {
        return !!email && !!name && !!city && !!occupation
      } else {
        return false
      }
    },
    // Logic danang
    getProfession () {
      return this.userInfo.profession_name
    },
    avatar () {
      return this.userInfo.avatar
    },
    urlServerImage () {
      return process.env.VUE_APP_URL_SERVER_IMAGE
    },
    // End Logic danang
    imageDropdown () {
      if (this.isOpenDetailMenu) {
        return 'https://cdn.karier.mu/assets/v3/icon/close-black.svg'
      } else {
        return 'https://cdn.karier.mu/assets/v3/icon/icon-bars.svg'
      }
    },
    imageDropdownLogin () {
      if (this.dropdownLogin) {
        return 'https://cdn.karier.mu/assets/v3/icon/close-black.svg'
      } else {
        return 'https://cdn.karier.mu/assets/v3/icon/icon-bars.svg'
      }
    },
    inputType () {
      if (this.isShowPassword) {
        return 'text'
      } else {
        return 'password'
      }
    },
    envBelajar () {
      return this.$store.state.envBelajar
    },
    activePrakerja () {
      return !this.$store.state.envBelajar
    },
    isDomainPrakerja () {
      if (window.location.hostname.includes('prakerja') || window.location.pathname.includes('prakerja')) {
        return true
      } else {
        return false
      }
    },
    errorHandling5xx_img () {
      if (window.innerWidth > 1000) {
        return errorHandler5xx_desktop
      } else {
        return errorHandler5xx_mobile
      }
    },
    errorHandling5xx_width () {
      if (window.innerWidth > 700) {
        return 328
      } else {
        return 278
      }
    },
    showReflection () {
      return process.env.VUE_APP_REFLECTION_CONFIG === 'show'
    },
    isHideMobileSidebar () {
      const paramsString = window.location.search
      const searchParams = new URLSearchParams(paramsString)
      return searchParams.get('header_hide') === 'true'
    },
    kariermuJobsEntry () {
      return this.$store.state.kariermuJobsEntry + '?utm_source=kariermu&utm_medium=navigation-bar-produk-kami'
    },
    isOpenNavbarRecommendation () {
      return this.$store.state.discovery.isOpenNavbarRecommendation
    },
    isDevEnv () {
      return process.env.VUE_APP_URL_SERVER.includes('dev')
    },
    hostname () {
      return this.isPrakerja ? process.env.VUE_APP_URL_REWRITE_PRAKERJA : process.env.VUE_APP_URL_REWRITE
    },
    btnProgrammuClass () {
      return this.$route.path === '/programmu' ? '' : 'text-gargoyle'
    }
  },
  watch: {
    emailUser (newValue, oldValue) {
      if (this.passwordUser && newValue) {
        this.isClickable = true
      } else {
        this.isClickable = false
      }
    },
    passwordUser (newValue, oldValue) {
      if (this.emailUser && newValue) {
        this.isClickable = true
      } else {
        this.isClickable = false
      }
    },
    searchTitle (val) {
      if (val === '') {
        this.openNavbarRecommendation()
        this.$store.commit('program/CHANGE_SEARCH_PROCESS', false)
      } else {
        this.activateOverlay(false)
        this.$store.commit('discovery/SET_IS_OPEN_NAVBAR_RECOMMENDATION', false)
      }
    },
    isLogin (isLogin) {
      if (isLogin && !this.professions.length) {
        this.$store.dispatch('profession/fetchProfessionList')
      }
    },
    '$route.path' (prev, next) {
      if (prev !== next) {
        if (!this.dropdownProfile) {
          return false
        } else {
          this.dropdownProfile = !this.dropdownProfile
        }
      }
    }
  },
  created () {
    this.fetchPopularKeyword()
    this.fetchSearchProgramRecommendation()
    this.fetchSearchInstitutionRecommendation()

    if (this.isLogin && !this.professions.length) {
      this.$store.dispatch('profession/fetchProfessionList')
    }

    // verification on every page by Harfi
    if (this.userVerification && this.codeVerification) {
      this.verification()
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleWindowResize)
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.handleWindowResize)
  }
}
</script>
<style>
.modal-dialog{
  margin: 1.5rem auto
}
</style>

<style scoped>
@import "../../styles/NavbarStyle.css";
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@500&display=swap');

.link-divider {
  margin-left: 24px;
  margin-right: 24px;
}

.navbar-wrapper {
  display: flex;
  padding: 16px;
  gap: 24px;
  justify-content: space-between;
  background-color: var(--color-neutral-100);
  min-height: 56px;
  box-shadow: 0px 2px 8px 0px rgba(51, 51, 51, 0.10);
}

.custom-mobile-search {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 16px;
  left: calc(16px + 40px);
}

.mobile-action-wrapper {
  display: flex;
  align-items: center;
  gap: 24px;
}

.action-button {
  text-decoration: none;
  padding: 8px;
}

.action-button:hover {
  background-color: var(--color-neutral-300);
  border-radius: 6px;
}

.desktop-action-wrapper,
.nav-right-container {
  display: none;
}

@media screen and (min-width: 1024px) {
  .mobile-action-wrapper {
    display: none;
  }

  .custom-mobile-search {
    position: relative;
    top: unset;
    right: unset;
    left: unset;
    transform: none;
    width: 350px!important;
    margin-left: auto;
  }

  .desktop-action-wrapper {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .navbar-wrapper {
    padding: 10px 48px;
  }

  .nav-right-container {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
  }

  .menu-divider {
    border-left: 1px solid var(--color-neutral-500);
    height: 24px;
  }
}

@media only screen and (min-width: 1140px) {
  .custom-mobile-search {
    width: 400px!important;
  }
}

@media only screen and (min-width: 1160px) {
  .custom-mobile-search {
    width: 500px!important;
  }
}

.user-avatar :deep(.s-avatar) {
  width: 32px;
  height: 32px;
  padding: 0;
}
</style>
